export default __webpack_public_path__ + "static/green-dots-blob-4-4d17446173f63d17a9f7ba7633fc0f16.svg";